import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { ResponseKashiKariSetting } from '@/repositories/fuzoku-meisai/junsoku/data'

type LongTermPostParam = {
  itemName: string;
  afterYearsSetting: Kamoku[];
  withinOneYearSetting: Kamoku[];
}

type ShortTermPostParam = {
  itemName: string;
  setting: Kamoku[];
}

export type PostParam = {
  longItems: LongTermPostParam[];
  shortItems: ShortTermPostParam[];
}

export interface KashitsukekinRepository {
  list (): Promise<ResponseKashiKariSetting>;

  save (param: PostParam): Promise<void>;
}

export class KashitsukekinRepositoryImpl implements KashitsukekinRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/kashitsukekin`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseKashiKariSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (param: PostParam): Promise<void> {
    await this.http.post(this.baseUrl, param)
  }
}
